import React from 'react';
import '../template-file-css/document-file-template.css';


export const KMS_FollowUp = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='KMS_FollowUp' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Follow up Template</h3></center></p>

                <p className='w-750'> <span className='eleHeader'>DIAGNOSIS:</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>MEDICATION:</span>
                    <textarea id='txtMedication' name='txtMedication' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>DATA:</span>
                    <textarea id='txtData' name='txtData' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>MSE:</span>
                    <textarea id='txtMse' name='txtMse' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>ASSESSMENT:</span>
                    <textarea id='txtAssessment' name='txtAssessment' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Impression:</span>
                    <textarea id='txtImpression' name='txtImpression' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>PLAN:</span>
                    <textarea id='txtPlan' name='txtPlan' className='add-only'></textarea>
                </p>

                <p className='w-750'>{`The patient ex-pressed understanding. Alternatives, risks, drug interactions (drug/drug, drug/food, drug/OTC, drug/herbs, drug/alcohol, drug/recreational drugs), benefits, adherence (benefits and consequences), and side effects of treatment (types, timing, frequency, and potential preventive measures) were discussed. Informed consent for all medications and treatment were obtained. The patient was involved in the decision-making and treatment planning of their care. Patient education provided on the importance of maintaining medication adherence. In the event of an emergency, the provider may ask the patient and/or family member and/or caregiver to contact 911. If it is not possible for the patient or someone at their location to contact 911, the Provider will contact 911 and provide the patient’s location. The patient was informed of this safety plan and verbally consented to it.`}
                </p>


            </div>
        </form>

    )
}











